import { Record } from 'immutable';

const {
    GET_INVOICES_REQUEST,
    GET_INVOICES_SUCCESS,
    GET_INVOICES_FAILURE,

    GET_INVOICE_PDF_REQUEST,
    GET_INVOICE_PDF_SUCCESS,
    GET_INVOICE_PDF_FAILURE,
} = require('./invoiceActions').constants;

const InitialState = Record({
    error: null,
    isFetching: false,
    invoices: {},
    isFetchingInvoices: false,
});

const initialState = new InitialState();

/**
 * ## galleryReducer function
 * @param {Object} state - initialState
 * @param {Object} action - type and payload
 */
export default function invoiceReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

    switch (type) {

    case GET_INVOICES_REQUEST:
        return state.set('isFetching', true).set('isFetchingInvoices', true)
            .set('error', null);

    case GET_INVOICE_PDF_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);

    case GET_INVOICES_SUCCESS:
        return state.set('isFetching', false).set('isFetchingInvoices', false)
            .set('invoices', payload);

    case GET_INVOICE_PDF_SUCCESS:
        return state.set('isFetching', false);

    case GET_INVOICES_FAILURE:
        return state.set('isFetching', false).set('isFetchingInvoices', false)
            .set('error', payload);

    case GET_INVOICE_PDF_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    default:
        return state;

    }
}
